var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "VInput",
    {
      staticClass: "df-checkbox",
      attrs: { value: _vm.model, rules: _vm.rules }
    },
    [
      _c("NsCheckbox", {
        staticClass: "input-checkbox",
        scopedSlots: _vm._u([
          {
            key: "label",
            fn: function() {
              return [
                _c("div", { domProps: { innerHTML: _vm._s(_vm.schema.label) } })
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.model,
          callback: function($$v) {
            _vm.model = $$v
          },
          expression: "model"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }